import { render, staticRenderFns } from "./form-file-classic.vue?vue&type=template&id=38072421&scoped=true"
import script from "./form-file-classic.ts?vue&type=script&lang=ts&external"
export * from "./form-file-classic.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38072421",
  null
  
)

export default component.exports